import styled from "styled-components";

interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}
export const Styles = styled.div<IProps>`
  .ant-select-selector {
    min-height: 40px !important;
    background: ${(props) =>
      props.background ? props.background + " !important" : ""};
    .ant-select-selection-item-content {
      color: ${(props) => (props.color ? props.color + " !important" : "")};
    }
  }
`;
